import React from 'react';
import Skeleton from "react-loading-skeleton";
import styles from "../RestaurantFavourites.module.css";

function RestaurantSliderSkeleton() {
    return (
        <div className={styles.rest_should_try} style={{lineHeight: 1}}>
            <Skeleton style={{width:"100%"}} height={441}/>
        </div>
    )
}
export default RestaurantSliderSkeleton;